import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DevicesTopic } from '../screens/company/topics/DevicesTopic';

/** Connected devices, beside Paige Scan under Company (docs/engineering/folder-monitor.md, section 7). */
export const Route = createFileRoute('/t/$tenant/settings/company/devices')({
  // `connected=1`: back from connecting this computer through the Add a computer drawer (connect-return.ts).
  validateSearch: z.object({
    connected: z.union([z.string(), z.number()]).optional().catch(undefined),
  }),
  component: DevicesTopic,
});
